import script from "./Price.vue?vue&type=script&setup=true&lang=js"
export * from "./Price.vue?vue&type=script&setup=true&lang=js"

import "./Price.vue?vue&type=style&index=0&id=9ebe335c&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ebe335c"]])

export default __exports__